import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'


const WeekModal = ({openModal, setOpenModal}) => {

    const [ showPlayer, setShowPlayer ] = useState(false)
    const [ imageLoaded, setImageLoaded ] = useState(false)
      const [ , setPlayerReady ] = useState(false)

    const handleVideo = () => {
        setShowPlayer(true)
    }

    useEffect(()=>{

        return ()=>{
            setOpenModal({is_open : false , info : {}})
        }
    },[setOpenModal])

    useEffect(() => {
        // reset loader when thumbnail changes or modal reopens
        setImageLoaded(false)
        setShowPlayer(false)
        setPlayerReady(false)
    }, [openModal?.info?.thumbnail, openModal?.is_open])

    // Warm up YouTube connections for faster player load
    useEffect(() => {
        if (!openModal?.is_open) return
        const urls = [
            'https://www.youtube.com',
            'https://www.google.com',
            'https://i.ytimg.com',
            'https://s.ytimg.com'
        ]
        const links = urls.map((href) => {
            const link = document.createElement('link')
            link.rel = 'preconnect'
            link.href = href
            link.crossOrigin = ''
            document.head.appendChild(link)
            return link
        })
        return () => {
            links.forEach((l) => {
                if (l && l.parentNode) l.parentNode.removeChild(l)
            })
        }
    }, [openModal?.is_open])

  return (
    <div>
          <Dialog
                open={openModal?.is_open}
                onClose={()=> setOpenModal({is_open : false , info : {}})}
                as='div'
                style={{ zIndex: '9999999999' }}
                className="fixed inset-0 z-10 flex md:justify-start justify-center flex-col items-center"
            >
                <Dialog.Overlay className="fixed inset-0 bg-black/60 z-10 backdrop-blur-[10px]" />
                <Dialog.Title/>
                <Dialog.Description/>
                <div className='z-50 my-auto flex flex-col justify-center items-center' >
                    <div className="relative max-w-xl w-[94%] my-auto rounded-2xl relative p-[1px]" style={{backgroundImage:  `linear-gradient(
  to right,
  rgba(255, 255, 255, 0.3) 0%,
  rgba(255, 255, 255, 1) 50%,
  rgba(255, 255, 255, 0.3) 100%
)`}} >

                        <div className="rounded-2xl" style={{
                        background: 'radial-gradient(53.11% 56.94% at 50% 50%, #26496A 0%, #182C3F 100%)',
                        boxShadow: '0px 0px 20px 0px #0000004D'
                    }}>
                        
                        <div className='relative w-full h-auto' aria-busy={!imageLoaded}>
                            {/* Pre-mounted player for faster start; hidden until showPlayer */}
                            <div className={`w-full rounded-t-2xl overflow-hidden ${showPlayer ? 'opacity-100' : 'opacity-0'} transition-opacity duration-150`}>
                                <ReactPlayer
                                    url={openModal?.info?.video_link}
                                    config={{
                                        file: { attributes: { preload: 'auto' } },
                                        youtube: { playerVars: { modestbranding: 1, rel: 0 } },
                                    }}
                                    width={'100%'}
                                    height={'210px'}
                                    controls={showPlayer}
                                    playing={showPlayer}
                                    onReady={() => setPlayerReady(true)}
                                />
                            </div>
                            {/* Thumbnail overlay */}
                            {!showPlayer && (
                                <div className='absolute inset-0 cursor-pointer' onClick={handleVideo}>
                                    {!imageLoaded && (
                                        <div className='absolute inset-0 z-10 flex items-center justify-center rounded-t-2xl bg-[#182C3F]'>
                                            <div className="spinner"/>
                                        </div>
                                    )}
                                    <img 
                                        src={openModal?.info?.thumbnail} 
                                        alt={openModal?.info?.description || 'Week thumbnail'} 
                                        width={200} 
                                        height={210} 
                                        loading='eager' 
                                        onLoad={() => setImageLoaded(true)}
                                        onError={() => setImageLoaded(true)}
                                        className={`w-full rounded-t-2xl h-auto ${imageLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-150`}
                                    />
                                    <img src="https://assets.learntube.ai/files/60422b53334ba439684e57bb/mingcute_youtube-fill.svg" className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[48px] h-[48px]' />
                                </div>
                            )}
                        </div>
                        <div className='pt-6 px-3 pb-3 flex flex-col justify-start items-start leading-none'>
                            <div className='font-bold text-[12px] text-white/50'>WEEK {openModal?.info?.id}</div>
                            <div className='mt-[6px] font-medium text-[18px] text-white '>{openModal?.info?.description}</div>
                            <div className='mt-4 font-bold text-[16px] text-[#70AEFF]'>You&apos;ll Get:</div>
                            <div className='mt-3 bg-[#406AFF]/10 rounded-[12px] p-3'>
                                {openModal?.info?.points?.map((item, index) => (
                                    <div key={index} className={`flex justify-start items-start gap-3 ${openModal?.info?.points?.length - 1 !== index && 'border-b-[1px] border-b-[#70AEFF]/20'} py-2`}>
                                    <FontAwesomeIcon icon={faCheck} size="lg" className='text-[#2BBD13]' />
                                    <p className='text-[14px] text-white leading-[140%]'>{item}</p>
                                    </div>
                                ))}
                            </div>

                        </div>

                        </div>
                    </div>
                    <div className="mt-4 bg-white/20 rounded-full w-[32px] h-[32px] flex justify-center items-center cursor-pointer" onClick={()=> setOpenModal({is_open : false , info : {}})}>
                            <img src="https://assets.learntube.ai/files/recognised_section/X.png?updatedAt=1746165712541" className='w-[28px] h-[28px]' />
                    </div>
                </div>
            </Dialog>
    </div>
  )
}

export default WeekModal